import React from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import {
  campaignManagementAccessControl,
  placementFromCollectionAccessControl,
} from '../access-control/campaignManagementAccess.configuration'

const PlacementFromCollectionCreatePage = React.lazy(
  () => import('../pages/placement-from-collection/PlacementFromCollectionCreatePage')
) as any

// @hygen:inject page-import

export const campaignManagementRouter = (
  <DomainRoute route="campaign-management" accessControl={campaignManagementAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="campaign-management-placement-from-collection-create"
        component={PlacementFromCollectionCreatePage}
        accessControl={placementFromCollectionAccessControl}
      />
      <DomainRoute
        exact
        route="campaign-management-placement-from-collection-edit"
        component={PlacementFromCollectionCreatePage}
        accessControl={placementFromCollectionAccessControl}
      />
      {/* @hygen:inject router-route
        injection point for routes, please do not delete */}
    </DashSwitch>
  </DomainRoute>
)
